import React from 'react';
import { observer } from 'mobx-react';
import { Catcher, ListWrapper } from '../';
import { usePaperTrailLogsFilterParams, useProfileIsRight } from '../../hooks';
import { cleanPaperTrailLogsStore, getPaperTrailLogsRelationSelect } from '../../middleware';
import { PaperTrailLogsTableList } from './Components';

export const PaperTrailLogs: React.FC = observer(() => {
    const filterParams = usePaperTrailLogsFilterParams();
    const isLord = useProfileIsRight('LORD');

    return (
        <Catcher>
            <ListWrapper
                cleanStore={cleanPaperTrailLogsStore}
                filterParams={filterParams}
                isNotFilterToolbar={!isLord}
                getRelationSelect={getPaperTrailLogsRelationSelect}
            >
                <PaperTrailLogsTableList />
            </ListWrapper>
        </Catcher>
    );
});
